<h2 mat-dialog-title>{{title  | translate | async}}</h2>
<mat-dialog-content>
<div class="Dialog-body">
  <form>
    <mat-form-field class="DBSS">
      <mat-select placeholder="{{'Leave Type'  | translate | async}}"   [(ngModel)]="selectedLeaveStatus" name="LeaveType" required>            
        <mat-option *ngFor="let type of leavesStatusList" [value]="type.Id">
          {{type.Status}} </mat-option>
        </mat-select> 
    </mat-form-field>

  </form>

  <div style="display: flex;min-width: 100%;height:40px">
       
     
   Attach Doc:      
    <i *ngIf="FilePreview!=''" style="cursor: pointer;vertical-align: bottom; margin-left: 10%;font-size: 40px; color: #3da14b;"
      class="material-icons" class="material-icons" (click)="onClickDownloadForm()">description</i>
     
   
</div>

<mat-form-field class="DBSS">
  <textarea matInput type="text" placeholder="{{'Notes' | translate | async}}" rows="4" name = "Notes"  [(ngModel)]="Notes" [disabled]="true">  </textarea>
</mat-form-field>

</div>
</mat-dialog-content>
<mat-dialog-actions style="align-items: flex-end;
display: flex;
flex-direction: row;
justify-content: flex-end;">
  <div class="buttonbelow">
    <button mat-raised-button (click)="DialogClose()">{{'Cancel'  | translate | async}}</button>     
    <button mat-raised-button (click)= "UpdateLeaveStatus()">{{'Update'  | translate | async}}</button>         

  </div>
</mat-dialog-actions>
